import React from "react";
import { Col, Container, Row } from "react-bs4grid";

import "./footer.scss";
import {useTranslation} from "react-i18next";

export default function Footer() {
  const {t} = useTranslation();
  return (
    <footer className="footer">
      <Container className="pt-48 pb-32">
        <Row>
          <Col>
            <img src="/logo-white.png" alt="plastx logo" />
            <div>{t("allRightsReserved")}</div>
          </Col>
        </Row>
        <Row className="pt-32">
          <Col>
            <h4>{t("help")}</h4>
            <ul>
              <li>
                <a rel="noopener noreferrer" href="https://www.collect.plastx.co/which-plastic">{t("collectTheRightPlastic")}</a>
              </li>
              <li>
                <a rel="noopener noreferrer" href="https://www.collect.plastx.co/about">{t("whatYouNeed")}</a>
              </li>
              <li>
                <a rel="noopener noreferrer" href="https://www.collect.plastx.co/all-about-payment">{t("plastXPayments")}</a>
              </li>
            </ul>
          </Col>
          <Col>
            <h4>{t("contactUs")}</h4>
            <ul>
              <li>
                <a rel="noopener noreferrer" href="mailto:hello@plastx.co">{t("generalEnquiries")}</a>
              </li>
              <li>
                <a rel="noopener noreferrer" href="mailto:hello@plastx.co">{t("reportAProblem")}</a>
              </li>
            </ul>
            <h4>{t("legals")}</h4>
            <ul>
              <li>
                <a rel="noopener noreferrer" href="https://www.collect.plastx.co/legal-stuff">{t("privacyPolicy")}</a>
              </li>
              <li>
                <a rel="noopener noreferrer" href="https://www.collect.plastx.co/legal-stuff">{t("terms")}</a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
